// extracted by mini-css-extract-plugin
export default {"icon":"FavoriteGroup-module-c245cfc5c7d7263677db"};